export default "__VITE_ASSET__DDVwbsND__"